import ELK from "elkjs/lib/elk.bundled";
import { useCallback, useRef } from "react";
const elk = new ELK();

const defaultOptions = {
  "elk.algorithm": "layered",
  "elk.direction": "RIGHT", // Layout from left to right
  "elk.layered.spacing.nodeNodeBetweenLayers": 100,
  "elk.spacing.nodeNode": 80,
  "elk.layered.crossingMinimization.strategy": "LAYER_SWEEP",
  "elk.layered.nodePlacement.strategy": "NETWORK_SIMPLEX",
  "elk.layered.layering.strategy": "NETWORK_SIMPLEX",
  // Improve edge routing
  // "elk.edgeRouting": "ORTHOGONAL",
  "elk.spacing.edgeNode": 30,
  "elk.spacing.edgeEdge": 15,
  // Reduce edge crossings
  // "elk.layered.considerModelOrder.strategy": "NODES_AND_EDGES",
  "elk.layered.considerModelOrder.strategy": "PREFER_EDGES",

  "elk.layered.crossingMinimization.semiInteractive": true,
};

export const useLayoutedElements = (setNodes, nodeDimensions) => {
  const nodeDimensionsRef = useRef(nodeDimensions);
  nodeDimensionsRef.current = nodeDimensions;

  const triggerLayout = useCallback(
    async (nodes, edges) => {
      const dims = nodeDimensionsRef.current;
      if (Object.keys(dims).length < nodes.length) {
        return;
      }

      const graph = {
        id: "root",
        layoutOptions: defaultOptions,
        children: nodes.map((node) => ({
          id: node.id,
          width: dims[node.id]?.width || 150,
          height: dims[node.id]?.height || 50,
        })),
        edges: edges.map((edge) => ({
          id: edge.id,
          sources: [edge.source],
          targets: [edge.target],
        })),
      };

      try {
        const layoutedGraph = await elk.layout(graph);
        const updatedNodes = nodes.map((node) => {
          const layoutNode = layoutedGraph.children.find(
            (n) => n.id === node.id
          );
          if (!layoutNode) return node;

          return {
            ...node,
            position: { x: layoutNode.x, y: layoutNode.y },
          };
        });

        setNodes(updatedNodes);
      } catch (error) {
        console.error("ELK layout error: ", error);
      }
    },
    [setNodes]
  );

  return triggerLayout;
};
export default useLayoutedElements;
